"use strict";
exports.__esModule = true;
exports.hasOptionalProperties = exports.hasProperties = exports.isInstance = exports.hasNumericIndexSignature = exports.hasStringIndexSignature = exports.isRecord = exports.hasOptionalProperty = exports.hasProperty = void 0;
var primitives_1 = require("./primitives");
/**
 * Validates that a given object has a property of a given type.
 *
 * @public
 */
exports.hasProperty = function (property, value) {
    return function (o) {
        // If the property exists and conforms to the value type guard.
        return value(o[property]);
    };
};
/**
 * Validates that a given object has an optional property of a given type.
 *
 * @public
 */
exports.hasOptionalProperty = function (property, value) {
    return function (o) {
        return !(property in o) ||
            // If the property exists and conforms to the value type guard.
            value(o[property]);
    };
};
/**
 * Validate that a variable is an object with a single field.
 *
 * If you need multiple fields then use hasProperties.
 *
 * @public
 */
exports.isRecord = function (property, value) {
    return function (o) { return primitives_1.isObject(o) && exports.hasProperty(property, value)(o); };
};
/**
 * Validates that a given object has a string index signature.
 *
 * @param enforce - Whether to enforce that there is at least one property already set. Be careful setting this to
 *   false, you will get some unexpected outputs, for instance arrays will have a string index signature.
 *
 * @public
 */
exports.hasStringIndexSignature = function (value, enforce) {
    if (enforce === void 0) { enforce = true; }
    return function (o) {
        var n = 0;
        for (var prop in o) {
            if (isNaN(parseInt(prop, 10))) {
                if (value(o[prop])) {
                    n++;
                }
                else {
                    return false;
                }
            }
        }
        /* eslint-disable-next-line no-magic-numbers */
        return !enforce || n > 0;
    };
};
/**
 * Validates that a given object has a numeric index signature.
 *
 * @param enforce - Whether to enforce that there is at least one property already set. Be careful setting this to
 *   false, you will get some unexpected outputs, for instance objects will have a numeric index signature.
 *
 * @public
 */
exports.hasNumericIndexSignature = function (value, enforce) {
    if (enforce === void 0) { enforce = true; }
    return function (o) {
        var n = 0;
        for (var prop in o) {
            if (!isNaN(parseInt(prop, 10))) {
                // We still index as a string here because prop is a string.
                if (value(o[prop])) {
                    n++;
                }
                else {
                    return false;
                }
            }
        }
        /* eslint-disable-next-line no-magic-numbers */
        return !enforce || n > 0;
    };
};
/**
 * Validates that a given object is an instance of a class.
 *
 * @public
 */
exports.isInstance = function (klass) {
    return function (o) { return o instanceof klass; };
};
/**
 * Validate that a given object has all the given properties
 *
 * @param props - a MappedGuard of the object to be validated, i.e. an object that has the same properties as the
 *    object being validated whose types are TypeGuards for the matching type on the original property.
 *
 * @public
 */
exports.hasProperties = function (props) {
    return function (o) {
        for (var prop in props) {
            if (!exports.hasProperty(prop, props[prop])(o)) {
                return false;
            }
        }
        return true;
    };
};
/**
 * Validate that a given object has all the given optional properties
 *
 * @param props - a MappedGuard of the object to be validated, i.e. an object that has the same properties as the
 *    object being validated whose types are TypeGuards for the matching type on the original property.
 *
 * @public
 */
exports.hasOptionalProperties = function (props) {
    return function (o) {
        for (var prop in props) {
            if (!exports.hasOptionalProperty(prop, props[prop])(o)) {
                return false;
            }
        }
        return true;
    };
};
//# sourceMappingURL=objects.js.map